import { Link } from "react-router-dom";
import styles from "./Header.module.scss";
import Logo from "../logo/Logo";

const Header = ({ links }) => {
  return (
    <div className={styles.header}>
      <Logo size="25px" />
      <ul className={styles.navbar}>
        <li>
          {links.map((link, index) => (
            <Link key={index} to={link.href}>{link.text}</Link>
          ))}
        </li>
      </ul>
    </div>
  );
};

export default Header;
